// extracted by mini-css-extract-plugin
export var alt = "HotelDetailsSection-module--alt--502f4";
export var desktopOnly = "HotelDetailsSection-module--desktopOnly--2456f";
export var main = "HotelDetailsSection-module--main--12a74";
export var mobileOnly = "HotelDetailsSection-module--mobileOnly--7a217";
export var textLeft = "HotelDetailsSection-module--textLeft--88572";
export var textRight = "HotelDetailsSection-module--textRight--346ac";
export var visuallyHidden = "HotelDetailsSection-module--visuallyHidden--ed5dc";